import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authStore } from '../api/client';

/**
 * ProtectedRoute
 *
 * Route guard that gates access to authenticated pages.
 *
 * Behaviour:
 *   - If the user is not authenticated  -> redirect to /login
 *   - If allowedRoles is provided and the user's role is not in it
 *                                       -> redirect to /unauthorized
 *   - Otherwise renders children
 *
 * Props:
 *   children     - optional element to render when access is allowed.
 *                  If omitted, falls back to <Outlet /> so this guard can be
 *                  used as a layout-route wrapper (React Router v6).
 *   allowedRoles - optional array of role strings (e.g. ['INTERVIEWER','ORG_ADMIN'])
 */
export default function ProtectedRoute({ children, allowedRoles }) {
  const location = useLocation();

  if (!authStore.isAuthenticated) {
    console.warn('[ProtectedRoute] not authenticated, redirecting to /login from', location.pathname);
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(authStore.role)) {
    console.warn(
      '[ProtectedRoute] role',
      authStore.role,
      'not allowed for',
      location.pathname,
      '- expected one of',
      allowedRoles
    );
    return <Navigate to="/unauthorized" replace />;
  }

  return children ?? <Outlet />;
}
